import { routes } from '@/router';
/**
 * @template S, R
 * @typedef {import('vuex').GetterTree<S, R>} GetterTree<S, R>
 */
/**
 * @typedef {import('@/store/root.state').RootState} RootState
 * @typedef {import('./layout-menu.state').LayoutMenuState} LayoutMenuState
 */

/** @type {GetterTree<LayoutMenuState, RootState>} */
export const layoutMenuGetters = {
  showMenu: (state) => Boolean(state.allowedMenuItems && state.allowedMenuItems.length > 1),
  isMenuItemAllowedByName: (state) => (name) => {
    if (!state.allowedMenuItems) return false;

    const allowedItem = state.allowedMenuItems.find((item) => item.name === name);

    return Boolean(allowedItem);
  },
  allowedMenuItems: (state, getters, rootState, rootGetters) => {
    const isUserAdmin = rootGetters['auth/account/isUserAdmin'];
    const adminOnlyRoutes = routes.filter((route) => !!route.isMenuItem && route.isAdminOnly);
    const adminMenuItems = isUserAdmin ? adminOnlyRoutes : [];
    const baseMenuItems = state.allowedMenuItems || [];
    
    return [...baseMenuItems, ...adminMenuItems];
  },
};
